<template>
  <VCard
    key="registration"
    class="login-form"
  >
    <div class="logo">
      <VLogo/>
    </div>

    <header>
      <router-link to="/login">
        Вход
      </router-link>
      /
      <span>Регистрация</span>
    </header>

    <VForm
      ref="form"
    >
      <div class="form">
        <VInput
          v-model="form.name"
          label="Имя"
          layout="vertical"
          required
          hide-asterisk
          name
          :max-length="20"
          @keyup.enter="onSubmit"
        />

        <VInput
          v-model="form.email"
          label="Почта"
          layout="vertical"
          required
          hide-asterisk
          type="email"
          autocomplete="email"
          @keyup.enter="onSubmit"
        />

        <VInputPhoneNumber
          v-model="form.phone"
          label="Телефон"
          layout="vertical"
          required
          hide-asterisk
          phone
          :max-length="20"
          @keyup.enter="onSubmit"
        />

        <FormAgreementCheckbox :form="form"/>

        <div class="actions-wrap">
          <VButton
            :disabled="isLoading"
            theme="primary"
            @click="onSubmit"
          >
            Регистрация
          </VButton>
        </div>
      </div>
    </VForm>
  </VCard>
</template>

<script>
import GlobalLoader from "@/core/services/GlobalLoader/GlobalLoader";

import LoginForm from "@/pages/common/LoginPage/LoginForm";

import VLogo from "@/lib/components/VLogo/VLogo.vue";
import ValidationFormMixin from "@/mixins/validation-form-mixin";
import FormAgreementCheckbox from "@/pages/common/LoginPage/components/FormAgreementCheckbox.vue";

export default defineComponent({
  name: 'RegistrationView',

  mixins: [
    ValidationFormMixin
  ],

  components: {
    FormAgreementCheckbox,
    VLogo
  },

  data() {
    return {
      form: new LoginForm(),
    };
  },

  computed: {
    isLoading() {
      return GlobalLoader.isVisible;
    },

    formValid() {
      return this.form.allAgreementsAccepted
        && this.form.name
        && this.form.email
        && this.form.phone;
    }
  },

  methods: {
    async onSubmit() {
      if (this.isLoading === true || this.formValid === false) {
        return;
      }

      await this.validate();

      if (this.isValid === false) {
        return;
      }

      this.form.saveAgreementFlagsToLocalStorage();

      // на самом деле тут вовсе не регистрация, а добавление лида
      try {
        GlobalLoader.show();

        const lead = {
          name: this.form.name,
          email: this.form.email,
          phone: this.form.phone,
          priority: 'medium',
          source: 'registration',
        };

        const response = await this.$core.rpc.makeLegacyRequest('leads.add', {lead});

        if (response.data) {
          this.$core.showNotification.success('Вы успешно зарегистрированы, наш менеджер свяжется с вами');
          this.$router.push('/login');
        } else {
          this.$core.showNotification.error('Ошибка сервера');
        }
      } catch (error) {
        this.$core.showNotification.error('Ошибка регистрации');
      } finally {
        GlobalLoader.hide();
      }
    },
  },
});
</script>
